import React from "react";
import { useParams, Navigate, Route, Routes } from "react-router-dom";
import ClassList from "views/admin/classes-mgmt/ClassList";
import ClassDetail from "views/admin/classes-mgmt/ClassDetail";
import ClassForm from "views/admin/classes-mgmt/ClassForm";
import SessionDetail from "views/admin/classes-mgmt/SessionDetail";
import SessionEditor from "views/admin/classes-mgmt/SessionEditor";

const CenterClassesMgmt = () => {
  const { centerId } = useParams<{ centerId: string }>();

  if (!centerId) return <Navigate to="/systemadmin/centers" replace />;

  return (
    <Routes>
      <Route index element={<ClassList centerId={centerId} />} />
      <Route path=":id" element={<ClassDetail />} />
      <Route path=":id/sessions/new" element={<SessionEditor />} />
      <Route path=":id/sessions/:sessionId" element={<SessionDetail />} />
      <Route path=":id/sessions/:sessionId/edit" element={<SessionEditor />} />
      <Route path=":id/edit" element={<ClassForm />} />
    </Routes>
  );
};

export default CenterClassesMgmt;
